import { FieldTypeCategory } from '@thinkalpha/language-services';
import { FieldType } from '@thinkalpha/table-client';
export const TypesInTypeCategory = new Map([
    [
        FieldTypeCategory.Double,
        [
            FieldType.Price,
            FieldType.Capital,
            FieldType.Quantity,
            FieldType.Volume,
            FieldType.Count,
            FieldType.Integral,
            FieldType.Float,
        ],
    ],
    [FieldTypeCategory.String, [FieldType.String, FieldType.Token, FieldType.Symbol, FieldType.Char]],
    [FieldTypeCategory.Ignored, [FieldType.CacheKey]],
    [FieldTypeCategory.Timestamp, [FieldType.TimeStamp, FieldType.Date]],
    [FieldTypeCategory.Enum, [FieldType.Enum]],
    [FieldTypeCategory.Bitmask, [FieldType.Bitmask]],
    [FieldTypeCategory.Boolean, [FieldType.Boolean]],
    [FieldTypeCategory.Index, [FieldType.Index]],
    [FieldTypeCategory.Regex, [FieldType.String]],
    [
        FieldTypeCategory.Timeframe,
        [
        // empty, because this is contrived for language services
        ],
    ],
]);
const categoryForFieldTypeInitializer = Object.keys(FieldType)
    .map((x) => FieldType[x])
    .map((x) => {
    for (const tc of TypesInTypeCategory) {
        if (tc[1].indexOf(x) !== -1)
            return [x, tc[0]];
    }
    return undefined;
})
    .filter((x) => x !== undefined);
export const CategoryForFieldType = new Map(categoryForFieldTypeInitializer);
Object.seal(CategoryForFieldType);
